import React, {Component} from 'react';
import {InputGroupAddon, InputGroupText} from 'reactstrap';
import _ from 'underscore';

export class RadioRow extends Component {

    render() {
        const props = this.props,
            value = props.value,
            line = props.line,
            property_name = line.property_name;
        return _.map(line.values, (object, key) => {
            return <InputGroupAddon
                key={key}
                addonType={key ? 'append' : 'prepend'}
            >
                <InputGroupText
                    className={'pointer-no-select'
                    + (value === object.value ? ' bg-dark text-white' : '')}
                    onClick={() => {
                        props.onChangeSettingsByNameValue(property_name, object.value);
                    }}
                >
                    {
                        object.name
                    }
                </InputGroupText>
            </InputGroupAddon>
        });
    }
}